import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ArrowBtn from "../../components/ArrowBtn";
import HorizontalLine from "../../components/HorizontalLine";
import BottomSheet from "../../components/modal/BottomSheet";
import QuestionBtn from "../../components/QuestionBtn";
import { useSelector } from "../../store";
import AiCommentServiceSettingGuide from "./AiCommentServiceSettingGuide";
const MyPadding = styled.div`
  padding-bottom: 48px;
`;
const AiCommentServiceSetting = () => {
  const { homeData } = useSelector((state) => state.home);
  const navigate = useNavigate()

  const ResponseAfterNthDay = () => {
    const responseAfterNthDay =
      homeData?.post_after_days > 0 ? homeData?.post_after_days : 0;
    if (responseAfterNthDay > 0) {
      return <span  onClick={() => navigate('/review/setting')} className="text-appblue">{responseAfterNthDay}일 후</span>;
    }
    return <span onClick={() => navigate('/review/setting')} className="text-[#767A85]">사용 안 함</span>;
  };

  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <HorizontalLine />
      <MyPadding>
        <div className="flex justify-between">
          <span className="flex items-center gap-1">
            <b className="text-base">댓글 자동 등록</b>
            <QuestionBtn onClick={openModal} />
          </span>
          <ArrowBtn size={16}>
            <ResponseAfterNthDay />
          </ArrowBtn>
        </div>
        <BottomSheet isOpen={isOpen} closeModal={closeModal}>
          <AiCommentServiceSettingGuide closeModal={closeModal} />
        </BottomSheet>
      </MyPadding>
    </>
  );
};

export default AiCommentServiceSetting;
